import { Route } from 'src/routes/Route'

export const BusinessRoute = Route({ path: '/business', hideTopBar: false })
export type BusinessRoute = Route<typeof BusinessRoute>
